<template>
  <div class="home">
    <PollScene id="scene"/>
    <PollCompetition id="competition"/>
    <PollArticles id="articles"/>
    <TheComments :url="projectUrl"/>
    <TheFooter/>
  </div>
</template>

<script>
import PollScene from '@/components/sections/PollScene'
import PollCompetition from '@/components/sections/PollCompetition'
import PollArticles from '@/components/sections/PollArticles'
import TheComments from '@/components/TheComments'
import TheFooter from '@/components/TheFooter'

export default {
  name: 'Home',
  components: {
    PollScene,
    PollCompetition,
    PollArticles,
    TheComments,
    TheFooter
  },
  inject: [ 'projectUrl' ]
}
</script>

<style lang="scss">
.home {
  background: #faf3ef;
}
</style>
